import { useState } from "react";

import { Form } from "antd";
import { connect, useSelector } from "react-redux";

import Loading from "../Common/Loading";
import RateInput from "./RateInput";
import Individual from "../Common/icons/Individual";
import Family from "../Common/icons/Family";
import Couple from "../Common/icons/Couple";
import Group3 from "../Common/icons/Group3";
import Business from "../Common/icons/Business";
import { createComment } from "../../Actions/DomesticHotelAction";

const DomesticHotelDetailCommentForm = props => {

    const { Dictionary } = props;
    const { getFieldDecorator } = props.form;

    const [status, setStatus] = useState();

    const [selectedRate, setSelectedRate] = useState(9);
    const [travelType, setTravelType] = useState("Individual");

    const user = useSelector(state => state.UserData.userData);

    let errorMessage = "";
    switch (status) {
        case "error":
            errorMessage = "ارسال اطلاعات با خطا روبرو شد. لطفا دوباره تلاش کنید."
            break;
        case "success":
            errorMessage = "دیدگاه شما با موفقیت ثبت شد و در انتظار تایید است."
            break;
        default:
            errorMessage = "";
    }

    const SubmitLoginHandler = (e) => {
        e.preventDefault();
        props.form.validateFields(async (err, values) => {
            if (!err) {
                setStatus('pending');

                const submitComment = async () => {
                    // setRateResponse();
                    const params = {
                        pageId: props.pageId,
                        userDisplayName: values.FullName,
                        comment: values.Comment,
                        overallRating: selectedRate,
                        travelType: travelType,
                        recommendToOthers: values.IsRecommended || false,
                        positivePoints: values.positivePoints,
                        negativePoints: values.negativePoints,
                        creationTime: new Date().toISOString(),
                        language: "fa-IR",
                        tenantId: +process.env.REACT_APP_SERVER_TENANTID,
                        userId: user?.id

                        //isVerifiedReviewer: false,
                        //isActive: user?.isActive,
                        //isAnonymous: values.isAnonymous,

                    };
                    try {
                        const response = await  createComment(params);

                        if (response?.data) {
                            setStatus('success');
                        } else {
                            setStatus('error');
                        }
                    } catch (e) {
                        console.dir(e);

                        setStatus('error');
                    }
                }

                submitComment();

            }
        });
    };
    const closeStatusModal = () => {
        if (status !== "pending") {
            setStatus();
        }
    }


    const travelTypeOptions = [
        { label: "انفرادی", value: "Individual", icon: <Individual className='medium-svg' /> },
        { label: "خانواده", value: "Family", icon: <Family className='medium-svg' /> },
        { label: "زوج", value: "Couple", icon: <Couple className='medium-svg' /> },
        { label: "گروهی", value: "Group", icon: <Group3 className='medium-svg' /> },
        { label: "کاری", value: "Business", icon: <Business className='medium-svg' /> }
    ];


    return (
        <>
            {!!status && <div className="itours-modal visible" >
                <div className="modal-overlay" onClick={closeStatusModal} />
                <div className="modal-inner small-width text-center">
                    <div className="modal-main">
                        {status === "pending" ?
                            <div className='padding-v-20'>
                                <Loading />
                            </div>
                            : (
                                <div>
                                    <br /><br />
                                    {status === "success" ?
                                        <span className="itours-icon check-green icon-xlarge" />
                                        :
                                        <span className="itours-icon error-icon icon-xlarge" />
                                    }
                                    <div className="margin-top margin-bottom">
                                        {errorMessage}
                                    </div>
                                    <br />
                                </div>
                            )}
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="button color-1-btn"
                            onClick={closeStatusModal}
                            disabled={status === "pending"}
                        >
                            {Dictionary.ok}
                        </button>
                    </div>
                </div>
            </div>}

            
            {status === 'pending' ?
                <div className='padding-v-20'>
                    <Loading />
                </div>
                :
                <Form onSubmit={SubmitLoginHandler} className="card-padding">

                    <h5 className="small-title">ثبت نظر </h5>

                    <p className='mb-3'>
                        با انتخاب يکی از گزینه‌های امتياز خود را به اين اقامتگاه ثبت کنید
                        <br />
                        ( 1 کمترین امتیاز و 10 بیشترین امتیاز)
                    </p>

                    <RateInput onChanage={setSelectedRate} />

                    <div className="margin-bottom">
                        <label className='block margin-bottom-light' > نوع سفر </label>

                        <div className="inline-radio">

                            {travelTypeOptions.map(option => (
                                <div className="radio-item" key={option.label}>
                                    <input
                                        className="custom-radio"
                                        type="radio"
                                        name='travelType'
                                        value={option.value}
                                        checked={option.value === travelType}
                                        onChange={e=>{
                                            if(e.target.checked){
                                                setTravelType(option.value)
                                            }
                                        }}
                                    />
                                    <label className="radio-label">
                                        <span className="radio-mark"></span>
                                        {option.icon} {option.label}
                                    </label>
                                </div>
                            ))}

                        </div>

                    </div>

                    <Form.Item className="no-margin form-group" label={Dictionary.fullName}>
                        {getFieldDecorator('FullName', {
                            rules: [{ required: true, message: 'نام و نام خانوادگی خود را وارد کنید.' }],
                        })(<input className="form-input" type="text" />)}
                    </Form.Item>

                    <Form.Item className="no-margin form-group" label="نکات مثبت">
                        {getFieldDecorator('positivePoints')(<input className="form-input" type="text" />)}
                    </Form.Item>    

                    <Form.Item className="no-margin form-group" label="نکات منفی">
                        {getFieldDecorator('negativePoints')(<input className="form-input" type="text" />)}
                    </Form.Item>

                    <Form.Item label="متن نظر" className="form-group">
                        {getFieldDecorator('Comment', {
                            rules: [{ required: true, message: "دیدگاه خود را وارد کنید." }],
                        })(
                            <textarea placeholder="متن نظر" className="full-width form-input hotel-comment-textarea"></textarea>
                        )}
                    </Form.Item>

                    <Form.Item className="form-group">
                        {getFieldDecorator('IsRecommended')(
                            <div className="checkbox-holder">
                                <input className="custom-checkbox" type="checkbox" />
                                <label className="checkbox-label"> پیشنهاد به دیگران </label>
                            </div>
                        )}
                    </Form.Item>

                    <div className="text-end">
                        <button 
                            type="button" 
                            className="margin-top margin-bottom button grey-btn large-btn margin-end" 
                            disabled={status === 'pending'}
                            onClick={props.closeForm}
                        >
                            لغو
                        </button>
                        <button type="submit" className="margin-top margin-bottom button blue-btn large-btn" disabled={status === 'pending'}>
                            ثبت
                            {status === 'pending' && <span className="loading-inline-circle margin-start-half" />}
                        </button>
                    </div>
                </Form>}
        </>
    )
}

const mapStateToProps = (state) => ({
    Dictionary: state.VisualData.Dictionary
});


export default connect(mapStateToProps)(Form.create({ name: 'comment' })(DomesticHotelDetailCommentForm));